var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.912 0H3.063A2.489 2.489 0 00.578 2.492v14.954a2.489 2.489 0 002.485 2.492h24.85a2.489 2.489 0 002.484-2.492V2.492A2.489 2.489 0 0027.912 0z",
    fill: "#016FD0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.68 16.69V9.587l12.608.011v1.963l-1.458 1.562 1.458 1.576v2.004H27.96l-1.236-1.368-1.228 1.373-7.817-.016z",
    fill: "#FFFFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.52 15.912v-5.544h4.686v1.277h-3.169v.867h3.094v1.256h-3.094v.852h3.17v1.292h-4.688z",
    fill: "#016FD0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.184 15.912l2.593-2.775-2.593-2.769h2.007l1.585 1.757 1.589-1.757h1.921v.044l-2.538 2.725 2.538 2.696v.079h-1.94l-1.613-1.775-1.596 1.775h-1.953z",
    fill: "#016FD0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.266 3.28h3.039l1.067 2.431V3.28h3.753l.646 1.821.65-1.821h2.865v7.105H15.144l3.122-7.105z",
    fill: "#FFFFFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.843 4.051l-2.452 5.54h1.682l.462-1.11h2.508l.462 1.11h1.724l-2.442-5.54h-1.944zm.211 3.187l.736-1.763.735 1.763h-1.471z",
    fill: "#016FD0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.207 9.59V4.05l2.365.009 1.216 3.405 1.225-3.413h2.276V9.59l-1.465.013V5.798L27.442 9.59h-1.337l-1.41-3.805V9.59h-1.488z",
    fill: "#016FD0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/Amex.12ace1729edeed80aa510697721755d6.svg";
export { ForwardRef as ReactComponent };